import { CustomSvg, SvgIconDefaultProps } from '@libs/components';
import { useTheme } from 'styled-components';

const PieChartIcon: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
  color,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.text.default;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9.16659 1C9.03398 1.00001 8.90681 1.0527 8.81305 1.14646C8.71928 1.24023 8.6666 1.3674 8.66659 1.5V6.83333C8.6666 6.96594 8.71928 7.09311 8.81305 7.18687C8.90681 7.28064 9.03398 7.33332 9.16659 7.33333H14.4999C14.6325 7.33332 14.7597 7.28064 14.8535 7.18687C14.9472 7.09311 14.9999 6.96594 14.9999 6.83333C14.9999 3.61748 12.3824 1 9.16659 1ZM9.66659 2.05013C11.9357 2.28526 13.7147 4.06423 13.9498 6.33333H9.66659V2.05013ZM7.16659 3C3.95073 3 1.33325 5.61748 1.33325 8.83333C1.33325 12.0492 3.95073 14.6667 7.16659 14.6667C10.3824 14.6667 12.9999 12.0492 12.9999 8.83333C12.9999 8.70073 12.9472 8.57356 12.8535 8.47979C12.7597 8.38603 12.6325 8.33335 12.4999 8.33333H7.66659V3.5C7.66657 3.3674 7.61389 3.24023 7.52012 3.14646C7.42636 3.0527 7.29919 3.00001 7.16659 3ZM6.66659 4.05013V8.83333C6.6666 8.96594 6.71928 9.09311 6.81305 9.18687C6.90681 9.28064 7.03398 9.33332 7.16659 9.33333H11.9498C11.6974 11.7691 9.67071 13.6667 7.16659 13.6667C4.49111 13.6667 2.33325 11.5088 2.33325 8.83333C2.33325 6.3292 4.23081 4.30253 6.66659 4.05013Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};
export default PieChartIcon;
